import { CSSProperties } from "react";

// Plain inline styles (no theme dependency) so it renders the same in the app,
// Storybook and Cypress without provider setup.

export const bezel: CSSProperties = {
  width: 260,
  borderRadius: 32,
  padding: "14px 10px",
  backgroundColor: "#1a1a1e",
  boxShadow: "0 12px 24px rgba(0,0,0,0.25)",
  boxSizing: "border-box",
};

export const bezelAndroid: CSSProperties = {
  ...bezel,
  borderRadius: 20,
};

export const screen: CSSProperties = {
  backgroundColor: "#f5f6f8",
  borderRadius: 20,
  overflow: "hidden",
  minHeight: 420,
  display: "flex",
  flexDirection: "column",
};

export const screenAndroid: CSSProperties = {
  ...screen,
  borderRadius: 10,
};

export const statusBar: CSSProperties = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: "8px 16px 4px",
  fontSize: 12,
  fontWeight: 600,
  color: "#1a1a1e",
};

export const statusIcons: CSSProperties = {
  display: "flex",
  alignItems: "center",
  gap: 4,
};

export const contactHeader: CSSProperties = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  padding: "8px 16px 16px",
  borderBottom: "1px solid rgba(0,0,0,0.06)",
};

export const avatar: CSSProperties = {
  width: 40,
  height: 40,
  borderRadius: "50%",
  backgroundColor: "#c7cad1",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color: "#fff",
  fontSize: 16,
  fontWeight: 700,
  marginBottom: 6,
};

export const contactNumber: CSSProperties = {
  fontSize: 13,
  fontWeight: 600,
  color: "#1a1a1e",
};

export const body: CSSProperties = {
  flex: 1,
  padding: 16,
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-end",
};

export const bubble: CSSProperties = {
  backgroundColor: "#e5e5ea",
  color: "#1a1a1e",
  borderRadius: 18,
  borderBottomLeftRadius: 4,
  padding: "10px 14px",
  fontSize: 14,
  lineHeight: 1.4,
  maxWidth: "85%",
  whiteSpace: "pre-wrap",
  wordBreak: "break-word",
};

export const bubbleAndroid: CSSProperties = {
  ...bubble,
  backgroundColor: "#ffffff",
  borderRadius: 10,
  borderBottomLeftRadius: 10,
  boxShadow: "0 1px 2px rgba(0,0,0,0.15)",
};

export const deliveredCaption: CSSProperties = {
  marginTop: 6,
  fontSize: 11,
  color: "#8e8e93",
};

export const emptyState: CSSProperties = {
  flex: 1,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  padding: 24,
  textAlign: "center",
  color: "#9a9aa0",
};

export const emptyTitle: CSSProperties = {
  fontSize: 13,
  fontWeight: 700,
  marginTop: 10,
  color: "#6b6b73",
};

export const emptyMessage: CSSProperties = {
  fontSize: 12,
  marginTop: 4,
  color: "#9a9aa0",
};
